import { Typography as TypographyAntd } from 'antd';
import styled from 'styled-components';

export const Title = styled(TypographyAntd.Title)`
  font-size: 14px !important;
  font-family: sans-serif !important;
  margin-bottom: 0 !important;
`;

export const Text = styled(TypographyAntd.Text)`
  font-size: 13px !important;
  font-family: sans-serif !important;
`;
